export class tRecurrJnlModel {

    entryNo: number;
    shopID: string;
    vouType: string;
    recurrID: string;
    lineNo: number;
    recurrName:string;
    jnlDate: Date;
    vouDate: Date;
    vendorNo: string;
    empNo: string;
    hdrRemark: string;
    refNo: string;
    chequeNo: string;
    analysis1No:string;
    analysis1: string;
    analysis2No:string;
    analysis2: string;
    acctNo: string;
    currCode: string;
    exRate: number;
    drAmtFC: number;
    drAmtBase: number;
    crAmtFC: number;
    crAmtBase: number;
    lineRemark: string;
    lastModifyDatetime: Date;
    lastModifyUserID: string;

}


export class RecurrJnlInsertModel extends tRecurrJnlModel {

    acctName: string;
    accNameFC: string;
    amountDecimal: number;
}



export class RecurrJnlPageSelectModel {

    recurrID: string;
    recurrName:string;
    totalAmount:number;
    vouType:string;
    shopID:string;
    data: RecurrJnlInsertModel;
}

export class RecurrJnlEditPageSearchResultModel {

    journalList: RecurrJnlInsertModel[];
    employeeName: string;
    vendorName: string;
    recurrID: string;
}